import { render, staticRenderFns } from "./Pathway.vue?vue&type=template&id=3f1deb56&"
import script from "./Pathway.vue?vue&type=script&lang=js&"
export * from "./Pathway.vue?vue&type=script&lang=js&"
import style0 from "./Pathway.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports